import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Dated commencement + jurisdiction pack. Not legal advice.
 * LAFRA Part 5 stays "not in force" until the pack row changes.
 */
export default function CivicLawBanner() {
    const [instrument, setInstrument] = useState(null);
    const [pack, setPack] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const [law, jur] = await Promise.all([
                    api.get("/civic/legislation", { params: { ref: "LAFRA 2024 Part 5" } }),
                    api.get("/civic/jurisdiction"),
                ]);
                setInstrument(law.data.instrument || null);
                setPack(jur.data.pack || null);
            } catch {
                // Banner is scaffolding. A miss must not block Guidance or Local help.
            }
        })();
    }, []);

    if (!instrument) return null;

    const statusLabel = String(instrument.status || "").replace(/_/g, " ");

    return (
        <section
            className="mt-6 rounded-lg border border-slate-200 bg-slate-50 px-4 py-3"
            data-testid="law-status-banner"
        >
            <div className="text-xs uppercase tracking-widest text-slate-500">Law status (dated pack)</div>
            <p className="text-sm text-slate-800 mt-1 m-0" data-testid="law-status-ref">
                {instrument.ref}: <strong>{statusLabel}</strong>
                {" · checked "}
                {instrument.checked_on}
                {instrument.verify_by ? ` · verify by ${instrument.verify_by}` : ""}
            </p>
            {instrument.note && <p className="text-xs text-slate-600 mt-1 m-0">{instrument.note}</p>}
            {pack?.challenge?.body_now?.name && (
                <p className="text-xs text-slate-600 mt-1 m-0">
                    Challenge forum in this pack today: {pack.challenge.body_now.name}. Not legal advice.
                </p>
            )}
            <p className="text-xs text-slate-500 mt-1 m-0">
                {pack?.disclaimer || instrument.source}
            </p>
        </section>
    );
}
